<agm-map
[ngStyle]="{'height': '400px' }"
#AgmMap
appDirectionsMap       
[mapTypeControl]="true"
[zoomControl]="true"
[fullscreenControl]="true"
(mapReady)="mapReady($event)"
[zoom]="3">  
</agm-map>